module.exports = __webpack_public_path__ + "static/img/certificate.ffe162a3.png";